<template>
  <div>
    <!-- <pre>{{modulePermission}}</pre> -->
    <!-- <pre>
    school {{ schoolAdmin }}
    create {{ createModuleAction }}
    edit {{ editModuleAction }}
    view {{ viewModuleAction }}
    delete {{ deleteModuleAction }}
        send {{ sendModuleAction }}action

     </pre
    > -->
    <!-- {{ViewtemplateData}} -->
    <vs-card class="sms-card">
       <div class="md:w-1/2 w-full p-1">
            <vs-input
                placeholder="Search"
                class="w-full"
                v-model="search"
                @keyup="searchFun"
                style="width: 100%"
              />
          </div>
      <vs-tabs>
        <vs-button
          color="danger"
          v-if="selected.length > 1 && checkDeletePermission()"
          @click="templateDeletePopup1"
          type="filled"
          >Bulk Delete</vs-button
        >
        <vs-tab label="" icon-pack="feather" icon="icon-inbox">
          <ag-grid-vue
            ref="agGridTable"
            :gridOptions="gridOptions"
             :defaultColDef="defaultColDef"
            class="ag-theme-material w-100 my-4 ag-grid-table"
            @row-selected="CellvalueSelectDeselect"
            :columnDefs="columnDefs"
            :rowData="templateList"
            rowSelection="multiple"
            colResizeDefault="true"
            :animateRows="true"
            :floatingFilter="false"
            :pagination="true"
            :suppressPaginationPanel="true"
            :enableRtl="$vs.rtl"
            @cell-clicked="cellSingleClicked"
            :style="{ minHeight: query_page.limit * 48 + 75 + 'px' }"
            :paginationPageSize="paginationPageSize"
            @grid-ready="onGridReady"
            @sortChanged="sortFun"
          >
          </ag-grid-vue>

          <div class="sm:flex justify-between items-center">
            <ItemsPerTableDropdown
              tableName="sms_template"
              @change="(pageLimit) => pageLimitSet = pageLimit"
            />
            <pagination
              :meta="query_page"
              @page-change="handlePageChange"
              class="cstm_pagination"
              style="float: right"
            />
          </div>
        </vs-tab>
      </vs-tabs>
      <vs-button
        class="compose-btn"
        @click="smsSidebar = true"
        type="filled"
        v-if="checkCreatePermission()"
        >Create Template</vs-button
      >

      <div class="full-cstm-sidebar mt-107" :class="{ open: smsSidebar }">
        <div class="mt-6 flex items-center justify-between px-6">
          <h4>
            <span v-if="editTemplateId">Edit</span>
            <span v-else>Create</span> SMS Template
          </h4>
          <feather-icon
            icon="XIcon"
            class="cursor-pointer"
            @click="handlcreateSidebar"
          />
        </div>
        <vs-divider class="mb-0" />

        <div class="p-6 pt-2 sidebar-scrollable-form">
          <div class="mb-4">
            <label>Platform Modules</label>
            <v-select
              v-model="templateData.platform_modules_id"
              v-validate="'required'"
              :reduce="(option) => option.platform_modules_id"
              label="module_name"
              name="module_name"
              :options="platformModuleslistArr"
              @input="getCommunicationTypeList()"
              style="width: 100%"
            />
          </div>

          <!-- {{templateData}} -->
          <div class="mb-4">
            <label>Module Actions</label>
            <v-select
              v-model="templateData.type_id"
              v-validate="'required'"
              :reduce="(option) => option.role_action_id"
              label="entity_name"
              name="action_name"
              :options="communicationTypeListArrList"
              style="width: 100%"
            />
          </div>
          <div class="mb-4">
            <vs-textarea
              class="w-full"
              label="Write SMS Template"
              v-model="templateData.template"
              ref="template_textarea"
            />
          </div>
          <vs-row vs-justify="space-between">
            <vs-col
              vs-type="flex"
              vs-justify="flex-start"
              vs-align="flex-start"
              vs-w="1"
            >
              <vs-checkbox
                v-model="templateData.is_default"
                class="mt-5 w-full"
                vs-value="1"
              ></vs-checkbox>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="flex-start"
              vs-align="flex-start"
              vs-w="11"
            >
              <label class="mt-5 w-full">Default</label>
            </vs-col>
          </vs-row>

          <vs-button
            v-if="editTemplateId"
            class="mt-4"
            :disabled="!buttonActive"
            @click="createTemplate"
            >Update</vs-button
          >

          <vs-button
            v-if="!editTemplateId"
            class="mt-4"
            :disabled="!buttonActive"
            @click="createTemplate"
            >Save</vs-button
          >
          <br />
          <br />
          <!-- <vs-divider  />
                <vs-row>
                    <vs-col vs-type="flex" vs-justify="flex-start" vs-align="flex-start">
                    <h6>Attach ICS File</h6>
                    </vs-col>
                
                </vs-row> -->

          <vs-divider />
          <!-- <vs-row vs-justify="space-between" class="mt-5">
                    <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="5">
                    <h6>Codes</h6>
                    <label class="code-hint">&nbsp;&nbsp;(Double click to append)</label>
                    
                    </vs-col>
                    
                    <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="7">
                    <h6>Description</h6>
                    </vs-col>
                </vs-row> -->
          <label>Codes with Description</label>
          <small>(Click to append)</small>
          <vs-divider />
          <!-- <vs-row vs-justify="space-between" class="mt-5" :key="index" v-for="(item, index) in attachICSFile">
                    <vs-col class="field_code" vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="5">
                    <h6 v-on:dblclick="appendCodeToTemplate(item.field_code)">{{item.field_code}}</h6>
                    
                    </vs-col>
                    
                    <vs-col class="field_description" vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="7">
                    <h6>{{item.field_description}}</h6>
                    </vs-col>
                    <vs-divider  />
                </vs-row> -->
          <div class="flex flex-wrap">
            <div
              class="outer-field-cstm-badge sm:w-1/2 w-full"
              style="padding: 0 5px"
              :key="index"
              v-for="(item, index) in attachICSFile"
            >
              <div class="field-cstm-badge">
                <a @click="appendCodeToTemplate(item.field_code)">{{
                  item.field_code
                }}</a>
                <a class="info"><span class="material-icons">info</span></a>
                <p class="description">{{ item.field_description }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bg-overlay"></div>

      <!-- View -->
      <vs-sidebar
        click-not-close
        position-right
        parent="body"
        :hidden-background="true"
        default-index="1"
        color="primary"
        class="sidebarx cstm-sidebarx sms-sidebar"
        spacer
        v-model="smsViewSidebar"
      >
        <div class="mt-6 flex items-center justify-between px-6">
          <h4>Template Details</h4>
          <feather-icon
            icon="XIcon"
            class="cursor-pointer"
            @click="handleViewSidebar"
          />
        </div>
        <vs-divider class="mb-0" />

        <div class="p-6 pt-2 sidebar-scrollable-form">
          <vs-row vs-justify="space-between">
            <vs-col
              vs-type="flex"
              vs-justify="flex-start"
              vs-align="flex-start"
              vs-w="6"
            >
              <h6>Platform Modules</h6>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="flex-start"
              vs-align="flex-start"
              vs-w="6"
            >
              <p>{{ ViewtemplateData.platform_module }}</p>
            </vs-col>
          </vs-row>
          <vs-divider />

          <vs-row vs-justify="space-between">
            <vs-col
              vs-type="flex"
              vs-justify="flex-start"
              vs-align="flex-start"
              vs-w="6"
            >
              <h6>Module Actions</h6>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="flex-start"
              vs-align="flex-start"
              vs-w="6"
            >
              <p>{{ ViewtemplateData.platform_module_action }}</p>
            </vs-col>
          </vs-row>
          <vs-divider />

          <vs-row vs-justify="space-between">
            <vs-col
              vs-type="flex"
              vs-justify="flex-start"
              vs-align="flex-start"
              vs-w="6"
            >
              <h6>Template:</h6>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="flex-start"
              vs-align="flex-start"
              vs-w="6"
            >
              <p v-html="this.ViewtemplateData.template"></p>
            </vs-col>
          </vs-row>
          <vs-divider />

          <!-- <vs-row vs-justify="space-between">
              <vs-col vs-type="flex" vs-justify="flex-start" vs-align="flex-start" vs-w="6">
              <h6>Subject:</h6>
              </vs-col>
              <vs-col vs-type="flex" vs-justify="flex-start" vs-align="flex-start" vs-w="6">
                <p v-html="this.ViewtemplateData.subject"></p>
              </vs-col>
              </vs-row>  -->

          <vs-row>
            <p class="mt-4"></p>
          </vs-row>
        </div>
      </vs-sidebar>
    </vs-card>
    <vs-popup title="Please confirm" :active.sync="deletepopupflag">
      <vs-row>
        <span>Are you sure to delete this template?</span>
      </vs-row>
      <vs-row vs-type="flex" vs-justify="flex-end" class="mt-4">
        <vs-button
          @click="deleteTemplate"
          color="red"
          type="filled"
          class="mr-2 vs-con-loading__container"
          >Accept</vs-button
        >
        <vs-button @click="cancelDeletePopup" type="border">Cancel</vs-button>
      </vs-row>
    </vs-popup>

    <vs-popup title="Please confirm" :active.sync="deletepopupflag1">
      <vs-row>
        <span>Are you sure to delete templates?</span>
      </vs-row>
      <vs-row vs-type="flex" vs-justify="flex-end" class="mt-4">
        <vs-button
          @click="templateBulkDelete"
          color="red"
          type="filled"
          class="mr-2 vs-con-loading__container"
          >Accept</vs-button
        >
        <vs-button @click="cancelMultipleDeletePopup" type="border"
          >Cancel</vs-button
        >
      </vs-row>
    </vs-popup>
  </div>
</template>

<script>
import Vue from 'vue'
import { AgGridVue } from 'ag-grid-vue'
import TemplateActionCell from './TemplateActionCell.vue'
import Bell from './Bell'
import Editor from '@tinymce/tinymce-vue'
import vSelect from 'vue-select'
import { contentFileUpload } from '@/api/course-builderapi'
import {
  smsDynamicFieldList,
  smsTemplateList,
  smsTypeList,
  smsTemplateCreate,
  smsTemplateDelete,
  smsTemplateShow,
  smsTemplateEdit
} from '@/api/sms.js'

import { platformModuleslist, communicationTypeList } from '@/api/email.js'

import { PermissionMiddleware } from '../../../mixins/middleware/PermissionMiddleware'
import Pagination from '@/components/common/pagination'

export default {
  name: 'SMS',
  components: {
    Bell,
    editor: Editor,
    vSelect,
    Pagination,
    AgGridVue,
    TemplateActionCell
  },
  mixins: [PermissionMiddleware],

  data: () => ({
    defaultColDef: {
      sortable: true,
      resizable: true,
      suppressMenu: true
      // autoHeight: true
    },
    search:'',
    sorting_obj: {
      field_type: '',
      attribute: '',
      direction: ''
    },
    communicationTypeListArr: [],
    platformModuleslistArr: [],
    typeOfsmsTemplate: '',
    editTemplateId: null,
    detailsView: [],
    smsViewSidebar: false,
    smsEditSidebar: false,
    image_url: '',
    deletepopupflag: false,
    deletepopupflag1: false,
    deleteTemplateId: '',
    templateData: {
      type_id: '',
      sms_body: '',
      template: '',
      is_default: '',
      platform_modules_id: ''
    },
    ViewtemplateData: {
      platform_module: '',
      platform_module_action: '',
      subject: '',
      template: '',
      is_default: ''
    },
    smsType: [],
    attachICSFile: [],
    checkBox1: '',
    selected: [],
    log: [],
    smsSidebar: false,
    templateList: [],
    query_page: {
      total: '',
      limit: 10,
      has_next: false,
      current_page: 1,
      next_page_url: null,
      previous_page_url: ''
    },
    pageLimitSet: null,
    gridApi: {},
    gridOptions: {
      accentedSort: true
    }
  }),
  created () {
    this.templateData.type_id = null
    this.templateData.template = ''
    this.templateData.is_default = ''
    this.templateData.platform_modules_id = ''

    const customer_id = localStorage.getItem('customer_id')
    const imageUploadUrl = process.env.VUE_APP_IMAGE_UPLOAD_URL
    this.image_url = `${imageUploadUrl}${customer_id}`
    //checking Permission
    const role_permission = localStorage.getItem('role_permission')
    if (role_permission == 1) {
      this.schoolAdmin = true
    } else {
      this.schoolAdmin = false

      this.getModulePermission('Communication', 'sms')
    }

    this.columnDefs = [
      {
        headerName: '',
        width: 60,
        field: 'isSelected',
        filter: false,
        checkboxSelection: (params) => {
          return true
        },
        headerCheckboxSelectionFilteredOnly: true,
        headerCheckboxSelection: true
      },
      {
        headerName: 'Description',
        field: 'sms_template'
      },
      {
        headerName: 'Module',
        field: 'module',
        width: 150,
        valueFormatter: (params) => `${params.data.platform_module.module_name}`
      },
      {
        headerName: 'Action Name',
        field: 'action_name',
        width: 250,
        valueFormatter: (params) => `${params.data.role_action.entity_name}`
      },
      {
        headerName: 'Default',
        field: 'is_default',
        // eslint-disable-next-line no-confusing-arrow
        valueFormatter: (params) => params.data.is_default ? 'Yes' : 'No'
      }
    ]

    if (this.checkEditPermission() || this.checkDeletePermission()) {
      this.columnDefs.push({
        headerName: 'Action',
        minWidth: 100,
        maxWidth: 100,
        field: 'action',
        cellRendererFramework: Vue.extend(TemplateActionCell),
        CellRendererParams: {
          templateEditSidebar: (data) => this.templateEditSidebar(data),
          templateDeletePopup: (id) => this.templateDeletePopup(id),
          checkEditPermission: () => this.checkEditPermission(),
          checkDeletePermission: () => this.checkDeletePermission()
        }
      })
    }
  },
  computed: {
    communicationTypeListArrList () {
      this.communicationTypeListArr = this.communicationTypeListArr.filter(
        (element) => {
          if (element.action_name != 'LeadActivity') return element
        }
      )
      return this.communicationTypeListArr
    },
    buttonActive () {
      if (
        this.templateData.type_id !== null &&
        this.templateData.template !== ''
      ) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    pageLimitSet () {
      this.handlePageChange(1)
    }
  },
  mounted () {
    this.gridApi = this.gridOptions.api

    this.getPlatformModuleslist()

    /* smsDynamicFieldList(localStorage.getItem('customer_id'))
      .then((res) => {
        this.attachICSFile = res.data.data.modules_list
        // 
      })
      .catch((e) => {
        
      })  */

    /* smsTemplateList(
      localStorage.getItem('customer_id'),
      this.query_page.current_page
    )
      .then((res) => {
        this.templateList = res.data.data.fields
        this.query_page = res.data.data.meta
        //
      })
      .catch((e) => {}) */
  },
  methods: {
    searchFun () {
      this.fetchListBySearch(this)
    },
    fetchListBySearch: _.debounce(async (vm) => {
      try {
        vm.handlePageChange(1)
      } catch (e) {
        console.log(e)
      }
    }, 1000),
    async sortFun () {
      try {
        const sortState = this.gridOptions.api.getSortModel()
        this.sorting_obj.field_type = 'system'
        this.sorting_obj.attribute = sortState[0].colId
        this.sorting_obj.direction = sortState[0].sort
        this.handlePageChange(1)
      } catch (e) {}
    },
    getSelectedRows () {
      const selectedNodes = this.gridApi.getSelectedNodes()
      const selectedData = selectedNodes.map((node) => node.data)

      return selectedData
    },
    onGridReady () {
      this.gridOptions.api.sizeColumnsToFit()
    },
    cellSingleClicked (params) {
      if (params.colDef.headerName !== 'Action') {
        this.templateViewSidebar(params.data.sms_template_id)
      }
    },
    paginationPageSize () {
      return this.pageLimitSet
    },
    CellvalueSelectDeselect () {
      this.gridApi = this.gridOptions.api

      const selectedNodes = this.gridApi.getSelectedNodes()
      //
      if (selectedNodes) {
        //
        const selecttedNode = this.gridApi.getSelectedNodes()
        this.selected = selecttedNode.map((node) => node.data)
      } else {
        this.selected = []
      }
    },
    handlePageChange (page) {
      if (!this.pageLimitSet) return
      
      this.selected.length = 0
      this.query_page.current_page = page
      // this.fetchQuestionBankList()
      const payload = {
        search:this.search
      }
      smsTemplateList(
        this.sorting_obj,
        'sms_template',
        payload,
        localStorage.getItem('customer_id'),
        this.query_page.current_page,
        this.pageLimitSet
      )
        .then((res) => {
          this.templateList = res.data.data.fields
          this.query_page = res.data.data.meta
        })
        .catch((e) => {})
    },
    async getPlatformModuleslist () {
      const data = await platformModuleslist()
      this.platformModuleslistArr = data.data.data.modules_list
      //
    },
    async getCommunicationTypeList () {
      // this.templateData.type_id = null
      const customer_id = localStorage.getItem('customer_id')
      const data = await communicationTypeList(
        customer_id,
        this.templateData.platform_modules_id
      )

      this.communicationTypeListArr = data.data.data.types
      this.attachICSFile = data.data.data.module_related_dynamic_field
      //
    },
    appendCodeToTemplate (field_code) {
      const template_textarea = this.$refs.template_textarea.$el.children[1]
      template_textarea.setRangeText(field_code)
      this.templateData.template = template_textarea.value

      //Notifications after appending code
      this.$vs.notify({
        title: 'Success',
        text: 'Code added',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'success',
        time: 2000
      })
    },
    images_upload_handler (blobInfo, success, failure) {
      const xhr = new XMLHttpRequest()
      xhr.withCredentials = true
      xhr.open('POST', this.image_url)

      xhr.upload.onprogress = function (e) {
        progress((e.loaded / e.total) * 100)
      }

      xhr.onload = function () {
        // let json

        if (xhr.status === 403) {
          failure(`HTTP Error: ${xhr.status}`, { remove: true })
          return
        }

        if (xhr.status < 200 || xhr.status >= 300) {
          failure(`HTTP Error: ${xhr.status}`)
          return
        }

        const json = JSON.parse(xhr.responseText)

        if (!json || typeof json.location !== 'string') {
          failure(`Invalid JSON: ${xhr.responseText}`)
          return
        }

        success(json.location)
      }

      xhr.onerror = function () {
        failure(
          `Image upload failed due to a XHR Transport error. Code: ${xhr.status}`
        )
      }

      xhr.setRequestHeader(
        'Authorization',
        `Bearer ${JSON.parse(localStorage.getItem('access_token'))}`
      )

      const formData = new FormData()
      formData.append('files[0]', blobInfo.blob(), blobInfo.filename())

      xhr.send(formData)
    },
    example_image_upload_handler (blobInfo, success, failure, progress) {
      const formData = new FormData()
      formData.append('files[0]', blobInfo.blob())

      const data = this.fileupload(formData)

      data
        .then((res) => {
          const locationObject = {
            src: {
              value: {
                location: res
              }
            }
          }

          const stringify = JSON.stringify(res)
          const parse = JSON.parse(stringify)

          success(parse)
        })
        .catch((error) => {})
    },

    async fileupload (payload) {
      try {
        const customer_id = localStorage.getItem('customer_id')

        const responseImage = await contentFileUpload(customer_id, payload)
        const location =
          responseImage.data.data.cdn +
          responseImage.data.data.files[0].file_path
        this.$vs.notify({
          title: 'Success',
          text: 'Image Uploaded Successfully',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success',
          time: 3000
        })
        return location
      } catch (error) {}
    },

    handlcreateSidebar () {
      this.smsSidebar = false
      this.resetData()
    },
    handleEditSidebar () {
      this.smsEditSidebar = false
      this.selected.length = 0
      this.templateData.type_id = null
      this.templateData.template = ''
      this.templateData.is_default = ''
    },
    templateEditSidebar (edit_template_Data) {
      this.templateData.type_id = null
      this.templateData.template = ''
      this.templateData.is_default = ''
      this.templateData.platform_modules_id = ''

      //
      this.editTemplateId = edit_template_Data.sms_template_id
      if (edit_template_Data.platform_module) {
        this.templateData.platform_modules_id =
          edit_template_Data.platform_module.platform_modules_id
        this.getCommunicationTypeList()
        this.templateData.type_id =
          edit_template_Data.role_action.role_action_id
        this.templateData.template = edit_template_Data.sms_template
        this.templateData.is_default = edit_template_Data.is_default
      }

      this.smsSidebar = true
    },
    templateViewSidebar (id) {
      this.smsViewSidebar = true
      smsTemplateShow(localStorage.getItem('customer_id'), id)
        .then((res) => {
          const data = res.data.data.fields
          //this.ViewtemplateData = data
          this.ViewtemplateData.template = data.sms_template
          this.ViewtemplateData.platform_module =
            data.platform_module.module_name
          this.ViewtemplateData.subject = data.subject
          this.ViewtemplateData.platform_module_action =
            data.role_action.action_name
          this.ViewtemplateData.is_default = data.is_default
        })
        .catch((e) => {})
    },
    handleViewSidebar () {
      this.smsViewSidebar = false
      this.selected.length = 0
    },
    getSelectedRows () {
      return this.selected
    },
    resetData () {
      this.templateData.type_id = null
      this.templateData.subject = ''
      this.templateData.template = ''
      this.templateData.is_default = ''
      this.templateData.platform_modules_id = ''
      this.editTemplateId = null
      this.attachICSFile = []
    },
    createTemplate () {
      if (this.templateData.is_default === '') {
        this.templateData.is_default = 0
      }

      if (this.editTemplateId !== null) {
        this.editTemplate()
      } else {
        smsTemplateCreate(
          localStorage.getItem('customer_id'),
          this.templateData
        )
          .then((res) => {
            //
            this.smsSidebar = false
            this.$vs.notify({
              title: 'Success',
              text: 'Template Created Successfully',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success'
            })
            this.resetData()
            const payload = {
              search:this.search
            }
            smsTemplateList(
              this.sorting_obj,
              'sms_template',
              payload,
              localStorage.getItem('customer_id'),
              this.query_page.current_page
            )
              .then((res) => {
                this.templateList = res.data.data.fields
                this.query_page = res.data.data.meta
              })
              .catch((e) => {})
          })
          .catch((e) => {
            this.$vs.notify({
              title: 'Warning',
              text: 'Something Went Wrong',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning'
            })
          })
      }
    },
    editTemplate () {
      if (
        this.templateData.is_default === null ||
        this.templateData.is_default === false
      ) {
        this.templateData.is_default = 0
      }
      //
      smsTemplateEdit(
        localStorage.getItem('customer_id'),
        this.editTemplateId,
        this.templateData
      )
        .then((res) => {
          //
          this.smsSidebar = false
          this.$vs.notify({
            title: 'Success',
            text: 'Template Edited Successfully',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success'
          })
          const payload = {
            search:this.search
          }
          smsTemplateList(
            localStorage.getItem('customer_id'),
            this.query_page.current_page
          )
            .then((res) => {
              this.templateList = res.data.data.fields
              this.query_page = res.data.data.meta
              this.selected.length = 0
              this.handleEditSidebar()
            })
            .catch((e) => {})
        })
        .catch((e) => {
          this.$vs.notify({
            title: 'Warning',
            text: 'Something Went Wrong',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning'
          })
        })

      // this.templateData.platform_modules_id = ''
      setTimeout(() => {
        //Removing Email Template Id Used for edit template API
        this.editTemplateId = null
      }, 2000)
    },

    cancelDeletePopup () {
      this.deletepopupflag = false
      this.selected.length = 0
    },
    cancelMultipleDeletePopup () {
      this.deletepopupflag1 = false
      this.selected.length = 0
    },
    templateDeletePopup (id) {
      this.deletepopupflag = true
      this.deleteTemplateId = id
    },
    deleteTemplate () {
      const payload = {
        deleteFields: [this.deleteTemplateId]
      }
      smsTemplateDelete(localStorage.getItem('customer_id'), payload)
        .then((res) => {
          this.$vs.notify({
            title: 'Success',
            text: 'Template Deleted Successfully',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success'
          })
          const payload = {
            search:this.search
          }
          smsTemplateList(
            localStorage.getItem('customer_id'),
            this.query_page.current_page
          )
            .then((res) => {
              if (
                res.data.data.fields.length === 0 &&
                !res.data.data.meta.next_page_url
              ) {
                this.handlePageChange(this.query_page.current_page - 1)
              } else {
                this.templateList = res.data.data.fields
                this.query_page = res.data.data.meta
              }
              this.selected.length = 0
              this.deletepopupflag = false
            })
            .catch((e) => {})
        })
        .catch((e) => {
          this.$vs.notify({
            title: 'Warning',
            text: 'Something Went Wrong',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning'
          })
        })
    },
    templateDeletePopup1 () {
      this.deletepopupflag1 = true
    },
    templateBulkDelete () {
      const BulkSelected = this.getSelectedRows()
      const deleting_ids = []
      for (let i = 0; i < BulkSelected.length; i++) {
        deleting_ids.push(BulkSelected[i].sms_template_id)
      }
      const payload = {
        deleteFields: deleting_ids
      }

      smsTemplateDelete(localStorage.getItem('customer_id'), payload)
        .then((res) => {
          this.$vs.notify({
            title: 'Success',
            text: 'Templates Deleted Successfully',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success'
          })
          const payload = {
            search:this.search
          }
          smsTemplateList(
            this.sorting_obj, 'sms_log_list',
            payload,
            localStorage.getItem('customer_id'),
            this.query_page.current_page
          )
            .then((res) => {
              if (
                res.data.data.fields.length === 0 &&
                !res.data.data.meta.next_page_url
              ) {
                this.handlePageChange(this.query_page.current_page - 1)
              } else {
                this.templateList = res.data.data.fields
                this.query_page = res.data.data.meta
              }

              this.deletepopupflag1 = false
              this.selected.length = 0
            })
            .catch((e) => {})
        })
        .catch((e) => {
          this.$vs.notify({
            title: 'Warning',
            text: 'Something Went Wrong',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning'
          })
        })
    }
  },

  beforeRouteLeave (to, from, next) {
    this.smsViewSidebar = false
    this.smsEditSidebar = false
    this.deletepopupflag = false
    this.deletepopupflag1 = false
    this.smsSidebar = false
    setTimeout(() => {
      next()
    }, 0)
  }
}
</script>

<style>
.vuesax-app-is-ltr .vs-sidebar.vs-sidebar-position-right {
  z-index: 1000;
}
.unread {
  background-color: #fff5ec;
  font-weight: 500;
}
.read {
  background-color: transparent !important;
  font-weight: 500;
}
.sms-table tr {
  box-shadow: 0 0 5px 1px rgba(0, 0, 0, 0.2);
}
.sms-card {
  position: relative;
}
.compose-btn {
  position: absolute;
  right: 10px;
  top: 10px;
  /* background: #FF9F43 !important; */
  /* box-shadow: 0 8px 25px -8px rgba(255, 159, 67, 1) !important; */
}
.sms-sidebar .vs-sidebar {
  max-width: 400px;
  margin-top: 107px;
}
.sms-sidebar .sidebar-scrollable-form {
  height: calc(100% - 175px);
  overflow-y: auto;
  overflow-x: hidden;
}
.sms-form input,
.sms-form input:focus {
  border: none !important;
  box-shadow: none;
}
.sub-line {
  border: none !important;
  height: 40px;
}

@media (max-width: 360px) {
  .sms-sidebar .vs-sidebar {
    max-width: 100%;
  }
}
.select_custom {
  height: 40px;
  border: none;
  background-color: white;
  border: 1px solid #cccccc;
  color: #787878;
  font-size: 14px;
  width: 100%;
  border-radius: 5px;
}

.field_code {
  cursor: pointer;
}

.code-hint {
  font-size: 8px;
  font-style: italic;
}
.field_code,
.field_description {
  justify-content: flex-start;
  display: flex;
  align-items: center;
  margin: 0%;
  background: #f6f6f6;
  width: 49% !important;
  word-break: break-all;
  padding: 10px;
  border-radius: 7px;
}
</style>